/**
 * @desc 保存物流追踪信息
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.TrasportTrackRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/trasportTrackSave`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
